import React from 'react';
import { Button, Space } from 'antd';
import { AuthWrapper } from '../../style';
import { useDispatch } from 'react-redux';
import { nextEvent } from '../../../../../../redux/authentication/actionCreator';
import './Prerequisite.css';

function Prerequisite() {
  const dispatch = useDispatch();

  const nextPage = () => {
    dispatch(nextEvent());
  };

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <div className="encore__welcome">
          <div className="encore__welcome__upper">
            <div className="encore__title">Before you get started</div>
            <div className="encore__desc">Make sure you are ready with all the essentials</div>
            <div className="encore__reminder__title"></div>
          </div>
          <div className="encore__reminder__container">
            <div className="encore__title">Essential</div>
            <div className="encore__reminder">
              <div className="encore__container">
                <div className="encore__icon">
                  <img src={require('../../../../../../static/img/icon/camera-icon.png')} alt="Chrome" />
                </div>
                <div className="encore__desc">
                  Have access to device camera for taking selfie and photo of your MyKad
                </div>
              </div>
              <div className="encore__container">
                <div className="encore__icon">
                  <img src={require('../../../../../../static/img/icon/mykad-icon.png')} alt="Chrome" />
                </div>
                <div className="encore__desc">Keep your MyKad handy as we need that to verify your identity</div>
              </div>
              <div className="encore__container">
                <div className="encore__icon">
                  <img src={require('../../../../../../static/img/icon/web-browser-icon.png')} alt="Chrome" />
                </div>
                <div className="encore__desc">
                  Use a supported browser i.e. <b>Google Chrome</b>, <b>Apple Safari</b>.
                </div>
              </div>
            </div>
          </div>
          <Space direction="vertical" style={{ width: '50%' }}>
            {/* <div className="encore__welcome__button"> */}
            <Button className="btn-create" type="primary" size="large" onClick={nextPage}>
              I Am Ready
            </Button>
            {/* </div> */}
          </Space>
        </div>
      </div>
    </AuthWrapper>
  );
}

export default Prerequisite;
